import { useState } from "react";
import { TextAreaInput } from "swing-components";

import {
  ModalCancelCommitmentsBody,
  ModalCancelCommitmentsFooter,
  ModalCancelCommitmentsHeader,
} from "~components";
import { msg } from "~utils";

import {
  type CancelFormState,
  type ModalCancelCommitmentsStep,
  type PenaltyAlert,
} from "../ModalCancelCommitments";

type ModalCancelCommitmentsPartialCancelDaysProps = {
  penaltyType: PenaltyAlert;
  cancelFormData: CancelFormState;
  setStep: (step: ModalCancelCommitmentsStep) => void;
  onDismiss: () => void;
  setCancelFormData: (data: CancelFormState) => void;
};

export function ModalCancelCommitmentsPartialCancelDays(
  props: ModalCancelCommitmentsPartialCancelDaysProps,
) {
  const { penaltyType, setStep, onDismiss, setCancelFormData, cancelFormData } = props;

  const [partialCancelText, setPartialCancelText] = useState("");

  return (
    <div className="modal-wrapper">
      <ModalCancelCommitmentsHeader onDismiss={onDismiss} />
      <ModalCancelCommitmentsBody penaltyType={penaltyType}>
        <div css={{ marginBottom: 16 }}>
          <TextAreaInput
            label={msg("CANCEL_COMMITMENT_MODAL_PARTIAL_CANCEL_DAYS_MESSAGE")}
            placeholder={msg("CANCEL_COMMITMENT_MODAL_PARTIAL_CANCEL_DAYS_PLACEHOLDER")}
            value={partialCancelText}
            onChange={(value) => {
              setPartialCancelText(value);
            }}
          />
        </div>
      </ModalCancelCommitmentsBody>
      <ModalCancelCommitmentsFooter
        buttonPrimary={{
          text: msg("LABEL_NEXT"),
          onClick: () => {
            if (partialCancelText.trim().length === 0) return;
            setCancelFormData({
              ...cancelFormData,
              partialCancelText: partialCancelText.trim(),
            });
            setStep("cancellation-reason");
          },
          isDisabled: partialCancelText.trim().length === 0,
        }}
        buttonSecondary={{
          text: msg("CANCEL_COMMITMENT_MODAL_BUTTON_CANCEL"),
          onClick: onDismiss,
          isDisabled: false,
        }}
      />
    </div>
  );
}
